import { Coins, Gift, BadgeCheck } from "lucide-react";
import Reveal from "./Reveal";

const BENEFITS = [
  {
    icon: Coins,
    tag: "REBATE",
    title: "Rebate untuk kalian sendiri.",
    desc: "Dapatkan rebate USD 15 untuk setiap lot yang memenuhi syarat. Kini, ada nilai tambahan dari aktivitas trading kalian.",
    span: "lg:col-span-7",
    extra: (
      <div className="mt-7 inline-flex items-baseline gap-3 rounded-2xl border border-gold/25 bg-gold/5 px-5 py-3.5">
        <span className="text-3xl font-black text-gold">$15</span>
        <span className="text-left text-[11px] font-bold uppercase leading-snug tracking-widest text-sage">
          USD / lot
          <br />
          yang memenuhi syarat
        </span>
      </div>
    ),
  },
  {
    icon: Gift,
    tag: "MILESTONE",
    title: "Lot terkumpul. Hadiah menanti.",
    desc: "Jelajahi pilihan gadget, kendaraan, hingga liburan. Lihat kebutuhan lot untuk setiap hadiah di bawah.",
    span: "lg:col-span-5",
    extra: (
      <div className="mt-7 flex flex-wrap justify-center gap-2">
        {["Gadget", "Motor", "Lifestyle"].map((t) => (
          <span key={t} className="rounded-full border border-emerald/25 bg-emerald/10 px-3.5 py-1.5 text-xs font-bold text-sage">
            {t}
          </span>
        ))}
      </div>
    ),
  },
  {
    icon: BadgeCheck,
    tag: "PERSYARATAN",
    title: "Mulai dari akun yang tepat.",
    desc: "Mau berkesempatan mendapatkan hadiah ini? Pastikan kalian menggunakan akun BOOSTER dan memenuhi syarat program.",
    span: "lg:col-span-12",
    extra: (
      <span className="mt-7 inline-flex rounded-full border border-emerald/30 bg-emerald/15 px-4 py-2 text-xs font-bold tracking-[0.2em] text-goldlight">
        AKUN BOOSTER
      </span>
    ),
  },
];

export default function Benefits() {
  return (
    <section id="keuntungan" data-testid="keuntungan" className="scroll-mt-24 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-bold tracking-[0.3em] text-goldlight">KEUNTUNGAN</p>
          <h2 className="mt-4 text-3xl font-black leading-tight text-cream sm:text-4xl md:text-5xl">
            Keuntungan kalau kalian trading di akun <span className="text-gold">BOOSTER.</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-12">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.tag} delay={i * 0.08} className={b.span}>
              <article
                data-testid={`benefit-card-${b.tag.toLowerCase()}`}
                className="group h-full rounded-3xl border border-emerald/15 bg-forest p-7 text-center transition-colors duration-300 hover:border-goldlight/50 md:p-9"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-emerald/30 bg-emerald/15 text-goldlight">
                  <b.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 text-xl font-black text-cream md:text-2xl">{b.title}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-sage md:text-base">{b.desc}</p>
                {b.extra}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
